/* Igniton — Ember Club. Pick products, light embers, join on the monthly plan.
   Adds each picked product with its selling plan, then puts the code for that
   product count on the cart (Cart API discount field) and goes to checkout. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function postJSON(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }
  function list(str) {
    return String(str || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function money(n) {
    var r = Math.round(n * 100) / 100;
    return '$' + (r % 1 ? r.toFixed(2) : String(r));
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countTo(el, to) {
    var from = parseFloat(String(el.textContent).replace(/[^0-9.]/g, '')) || to;
    if (reduce || from === to) { el.textContent = money(to); return; }
    var t0 = null, dur = 600;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round(from + (to - from) * e));
      if (k < 1) requestAnimationFrame(step); else el.textContent = money(to);
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    if (root.__igEc) return; root.__igEc = true;
    var prices = list(root.getAttribute('data-prices')).map(Number);
    var codes = list(root.getAttribute('data-codes'));
    var retail = Number(root.getAttribute('data-retail')) || 199;
    var items = [].slice.call(root.querySelectorAll('[data-ig-ec-item]'));
    var meter = root.querySelector('.ig-ec__meter');
    var each = root.querySelector('[data-ig-ec-each]');
    var line = root.querySelector('[data-ig-ec-line]');
    var hint = line ? line.textContent : '';
    var go = root.querySelector('[data-ig-ec-go]');
    var label = root.querySelector('[data-ig-ec-label]');
    var err = root.querySelector('[data-ig-ec-err]');
    var bar = root.querySelector('[data-ig-ec-bar]');
    var barP = root.querySelector('[data-ig-ec-bar-p]');
    var rungs = [].slice.call(root.querySelectorAll('[data-rung]'));

    function picked() { return items.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; }); }

    function render() {
      var n = picked().length, lvl = Math.min(n, 4);
      var p = prices[Math.max(lvl, 1) - 1] || prices[0];
      meter.setAttribute('data-lvl', lvl);
      root.style.setProperty('--lvl', lvl);
      root.setAttribute('data-lvl', lvl);
      rungs.forEach(function (r) {
        var i = Number(r.getAttribute('data-rung'));
        r.classList.toggle('is-lit', i <= lvl);
        r.classList.toggle('is-now', i === lvl);
      });
      countTo(each, p);
      if (barP) barP.textContent = money(p);
      if (n) {
        var total = p * n, save = (retail - p) * n;
        line.innerHTML = money(total) + ' a month for ' + n + ' product' + (n > 1 ? 's' : '') +
          ' · <b>you save ' + money(save) + '/mo</b>';
        var next = prices[lvl];
        if (lvl < 4 && next && lvl < items.length) {
          line.innerHTML += '<br><span class="ig-ec__next">Add one more and every product drops to ' + money(next) + '.</span>';
        }
        label.textContent = root.getAttribute('data-cta') + ' · ' + money(total) + '/mo';
      } else {
        line.textContent = hint;
        label.textContent = root.getAttribute('data-empty');
      }
      go.disabled = !n;
      root.classList.toggle('has-pick', !!n);
    }

    items.forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && !reduce) { b.classList.remove('is-spark'); void b.offsetWidth; b.classList.add('is-spark'); }
        render();
      });
    });

    go.addEventListener('click', function () {
      var sel = picked();
      if (!sel.length || go.classList.contains('is-busy')) return;
      go.classList.add('is-busy');
      if (err) err.hidden = true;
      var n = Math.min(sel.length, 4);
      var code = codes[n - 1];
      var payload = sel.map(function (b) {
        return { id: Number(b.getAttribute('data-variant')), quantity: 1, selling_plan: Number(b.getAttribute('data-plan')) };
      });
      postJSON('cart/add.js', { items: payload })
        .then(function () {
          if (!code || root.getAttribute('data-auto-apply') !== 'true') return null;
          return postJSON('cart/update.js', { discount: code }).catch(function () {});
        })
        .then(function () {
          window.location.href = root.getAttribute('data-return') || (ROOT + 'checkout');
        })
        .catch(function (e) {
          if (window.console) console.warn('[ig-ember-club]', e);
          go.classList.remove('is-busy');
          if (err) err.hidden = false;
        });
    });

    /* Small sticky bar on phones while the panel is off screen. */
    if (bar && 'IntersectionObserver' in window) {
      var panel = root.querySelector('.ig-ec__panel');
      var inView = { root: false, panel: false };
      var sync = function () {
        var show = inView.root && !inView.panel && picked().length > 0;
        bar.classList.toggle('is-on', show);
        bar.inert = !show;
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView[e.target === panel ? 'panel' : 'root'] = e.isIntersecting; });
        sync();
      }).observe(panel);
      new IntersectionObserver(function (es) { inView.root = es[0].isIntersecting; sync(); }).observe(root);
      items.forEach(function (b) { b.addEventListener('click', sync); });
      /* The bar's button joins straight away, same as the panel button. */
      root.querySelector('[data-ig-ec-bar-go]').addEventListener('click', function () { go.click(); });
    }

    render();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-ig-ec]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
